import { render } from "./HeaderIpBrandEditModal.vue?vue&type=template&id=dce7c1f2&scoped=true"
import script from "./HeaderIpBrandEditModal.vue?vue&type=script&lang=js"
export * from "./HeaderIpBrandEditModal.vue?vue&type=script&lang=js"

import "./HeaderIpBrandEditModal.vue?vue&type=style&index=0&id=dce7c1f2&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce7c1f2"]])

export default __exports__